import { ModelApiService } from './BaseApiService'

export default class DoceboApiService extends ModelApiService {
  constructor() {
    super('integrations/docebo')
  }

  /**
   * Returns object containing url with token to sign into GrowthHub
   */
  getSsoUrl() {
    return this.get('sso-url')
  }
}
